import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const DeleteModal = ({
  show,
  onDeleteClick,
  onCloseClick,
  isDeleting,
  title = "Are you sure?",
  message = "Are you sure you want to remove this record?",
  confirmLabel = "Delete",
  confirmingLabel = "Deleting...",
}) => {
  return (
      <Modal isOpen={show} toggle={onCloseClick} centered={true}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <lord-icon
                src="https://cdn.lordicon.com/gsqxdxog.json"
                trigger="loop"
                colors="primary:#f7b84b,secondary:#f06548"
                style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>{title}</h4>
              <p className="text-muted mx-4 mb-0">
                {message}
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
              className="btn btn-light"
              onClick={onCloseClick}
              disabled={isDeleting}
          >
            Cancel
          </button>
          <button
              className="btn btn-danger"
              onClick={onDeleteClick}
              disabled={isDeleting}
          >
            {isDeleting ? confirmingLabel : confirmLabel}
          </button>
        </ModalFooter>
      </Modal>
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
  isDeleting: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  confirmingLabel: PropTypes.string,
};

export default DeleteModal;
